import { render, staticRenderFns } from "./BeginIdentityVerification.vue?vue&type=template&id=2ae50d8c&scoped=true"
import script from "./BeginIdentityVerification.vue?vue&type=script&lang=js"
export * from "./BeginIdentityVerification.vue?vue&type=script&lang=js"
import style0 from "./BeginIdentityVerification.vue?vue&type=style&index=0&id=2ae50d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae50d8c",
  null
  
)

export default component.exports